import React from "react";

/**
 * Modern Badge Component
 * Variants: success, warning, danger, info, default
 */
const Badge = ({ children, variant = "default", size = "md", icon, className = "" }) => {
  const baseClasses = "inline-flex items-center gap-1 font-semibold rounded-full transition-all duration-200";

  const variantClasses = {
    success: "bg-gradient-to-r from-green-100 to-green-200 text-green-800 border border-green-300",
    warning: "bg-gradient-to-r from-yellow-100 to-yellow-200 text-yellow-800 border border-yellow-300",
    danger: "bg-gradient-to-r from-red-100 to-red-200 text-red-800 border border-red-300",
    info: "bg-gradient-to-r from-blue-100 to-blue-200 text-blue-800 border border-blue-300",
    purple: "bg-gradient-to-r from-purple-100 to-purple-200 text-purple-800 border border-purple-300",
    default: "bg-gradient-to-r from-gray-100 to-gray-200 text-gray-800 border border-gray-300",
  };

  const sizeClasses = {
    sm: "px-2 py-0.5 text-xs",
    md: "px-3 py-1 text-sm",
    lg: "px-4 py-1.5 text-base",
  };

  return (
    <span className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${className}`}>
      {icon && <span>{icon}</span>}
      <span>{children}</span>
    </span>
  );
};

export default Badge;

